import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.18.0_@capacitor+preferences@7.0.1_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_bfa5f24d81766dba992c52a6d53e701f/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}